import React from "react";
import { useHistory } from "react-router-dom";

const UniversalLogout = ({ setIsLoggedIn, inline = false }) => {
  const history = useHistory();

  const handleLogout = () => {
    // Navigate to the universal logout message page
    history.replace("/UniversalLogoutMessage");
  };

  const containerStyle = inline 
    ? {} 
    : { position: "absolute", top: "120px", right: "40px" };

  return (
    <div style={containerStyle}>
      <button
        onClick={handleLogout}
        style={{
          backgroundColor: "#dc3545",
          color: "white",
          border: "none",
          borderRadius: "8px",
          padding: "12px 24px",
          fontSize: "16px",
          fontWeight: "500",
          cursor: "pointer",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          transition: "all 0.2s ease",
        }}
        onMouseOver={(e) => {
          e.target.style.backgroundColor = "#c82333";
          e.target.style.transform = "translateY(-1px)";
          e.target.style.boxShadow = "0 4px 8px rgba(0,0,0,0.15)";
        }}
        onMouseOut={(e) => {
          e.target.style.backgroundColor = "#dc3545";
          e.target.style.transform = "translateY(0)";
          e.target.style.boxShadow = "0 2px 4px rgba(0,0,0,0.1)";
        }}
      >
        Logout
      </button>
    </div>
  );
};

export default UniversalLogout;
